export const SOFTLINE_ABSATZPLAN_PLACEHOLDER = '';

export const PLANVARIANTE_MAP = {
  'plangruppe': ['plangruppe', 'kundengruppe', 'kunde', 'artikelgruppe', 'artikel'],
  'artikel': ['plangruppe', 'artikelgruppe', 'artikel', 'kundengruppe', 'kunde'],
}

export const SOFTLINE_FEATURE_ABSATZPLAN = 'produktionAbsatzplanStore';
export const SOFTLINE_FEATURE_ABSATZPLAN_VERSIONEN = 'produktionAbsatzplanVersionenStore';

// Daten eingaben wenn Status = "B", sonst readonly - darf nur weiterschalten wenn status "B"
export const SOFTLINE_PERMISSION_ABSATZPLAN_BEARBEITER = 'ABSATZPLAN.BEARBEITER'

// Darf Pläne zurücksetzen wenn status "P" und weiterschalten von "P" (auf "F")
export const SOFTLINE_PERMISSION_ABSATZPLAN_PRUEFER = 'ABSATZPLAN.PRUEFER'

// Darf Pläne generell auf alle Stati setzen
export const SOFTLINE_PERMISSION_ABSATZPLAN_ADMIN = 'ABSATZPLAN.ADMIN'
